import type { TOC } from '@ember/component/template-only'
import { hash } from '@ember/helper'
import { array } from '@ember/helper'
import { LinkTo } from '@ember/routing'
import { t } from 'ember-intl'
import { Product } from 'teacher-ui-client/utils/products'
import { ActivityType } from 'teacher-ui-client/components/assignments-admin/assignment-form'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

export const CreateAssignmentLink: TOC<unknown> = <template>
  <LinkTo
    @route="assignments.product.create"
    @models={{array Product.REX}}
    @query={{hash activityType=ActivityType.RexLibraryReadAloud}}
    class="inline-flex items-center gap-1"
  >{{t "assignments.create.link"}}
    <PhosphorIcon @icon="phosphor-arrow-circle-right-fill" class="h-5 w-5" />
  </LinkTo>
</template>
